import { Component, OnInit, ViewChild } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { LoadingComponent } from '../../objects/loading/loading.component';
import { InfoComponent } from '../../objects/info/info/info.component';
import { ConceptoPlanilla } from 'src/app/Models/planilla/concepto-planilla';
import { DataService } from 'src/app/Service/data.service';

@Component({
  selector: 'app-conceptp-planilla',
  templateUrl: './conceptp-planilla.component.html',
  styleUrls: ['./conceptp-planilla.component.css']
})
export class ConceptpPlanillaComponent implements OnInit {

  @ViewChild(LoadingComponent, null) loading: LoadingComponent;
  @ViewChild(InfoComponent, null) info: InfoComponent;

  public search    = '';
  public page: any;
  public total     = 0;
  public items: ConceptoPlanilla[] = [];
  public nuevo: ConceptoPlanilla   = new ConceptoPlanilla();
  public agregando                 = false;
  private _backup: {[id: number]: any} = {};

  constructor(private data: DataService, private title: Title) {}

  ngOnInit() {
    this.title.setTitle('Conceptos de Planilla | Sistema');
    this.GetData();
  }

  GetData() {
    this.loading.show('Cargando...');
    this.items = [];
    const req = this.search
      ? this.data.GetFromValue(this.data.api.concepto_planilla, 'nombre__icontains', this.search)
      : this.data.GetSimple(this.data.api.concepto_planilla);
    req.subscribe(
      r => { this.loading.hide(); this.items = r; this.total = r.length; },
      e => { this.loading.hide(); this.info.error(e, () => {}); }
    );
  }

  ShowNew()   { this.nuevo = new ConceptoPlanilla(); this.agregando = true; }
  CancelNew() { this.agregando = false; this.nuevo = new ConceptoPlanilla(); }
  formNewValid(): boolean { return !!(this.nuevo.codigo && this.nuevo.nombre); }

  SaveNew() {
    this.loading.show('Registrando...');
    this.data.Post(this.data.api.concepto_planilla, this.nuevo).subscribe(
      r => { this.loading.hide(); this.agregando = false; this.nuevo = new ConceptoPlanilla(); this.GetData(); },
      e => { this.loading.hide(); this.info.error(e, () => {}); }
    );
  }

  StartEdit(item: ConceptoPlanilla)  { this._backup[item.idconcepto] = { ...item }; item.editando = true; }
  CancelEdit(item: ConceptoPlanilla) { Object.assign(item, this._backup[item.idconcepto]); item.editando = false; }

  SaveEdit(item: ConceptoPlanilla) {
    this.loading.show('Actualizando...');
    this.data.Put(this.data.api.concepto_planilla, `${item.idconcepto}`, item).subscribe(
      r => { this.loading.hide(); item.editando = false; delete this._backup[item.idconcepto]; },
      e => { this.loading.hide(); this.info.error(e, () => {}); }
    );
  }

  ShowDelete(item: ConceptoPlanilla) {
    this.info.show(`¿Deseas eliminar el concepto "${item.nombre}"?`, 1, null,
      { cancelText: 'No, Cancelar', successText: 'Sí, Eliminar', isCancel: true },
      () => this.Delete(item), () => { this.info.hide(); }, 20);
  }

  Delete(item: ConceptoPlanilla) {
    this.loading.show('Eliminando...');
    this.data.Delete(this.data.api.concepto_planilla, `${item.idconcepto}`).subscribe(
      r => { this.loading.hide(); this.info.show(r.message, 2, null, null, () => { this.info.hide(); this.GetData(); }); },
      e => { this.loading.hide(); this.info.error(e, () => this.info.hide()); }
    );
  }
}
